/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeButton } from "../../d-button";
import { DThemeDarkButtonBase } from "./d-theme-dark-button-base";

export class DThemeDarkButton<VALUE = unknown>
	extends DThemeDarkButtonBase<VALUE>
	implements DThemeButton<VALUE> {}
